import React, { Component, useCallback } from 'react';
import { useMutation } from 'react-apollo-hooks';
import { Link, withRouter } from 'react-router-dom';
import { Formik, Form, Field } from 'formik';
import classNames from 'classnames';
import gql from 'graphql-tag';

const LOGIN_MUTATION = gql`
  mutation login($login: String!, $password: String!) {
    login(login: $login, password: $password) {
      token
      refreshToken
    }
  }
`;

const Login = props => {
  const [handleLogin] = useMutation(LOGIN_MUTATION);

  const login = useCallback(async credentials => {
    if (!credentials) {
      return;
    }

    const { login, password } = credentials;

    try {
      const { data } = await handleLogin({
        variables: {
          login,
          password,
        },
      });

      const {
        login: { token, refreshToken },
      } = data;

      localStorage.setItem('token', token);
      localStorage.setItem('refreshToken', refreshToken);

      if (token) {
        props.history.push('/');
      }
    } catch (e) {
      console.log('error', e);
    }
  }, []);

  return (
    <div className="login">
      <div className="login-form-wrapper">
        <Formik
          initialValues={{
            login: '',
            password: '',
          }}
          onSubmit={(payload, { setSubmitting }) => {
            setSubmitting(true);

            login(payload);
          }}
          render={({ values, handleSubmit, isSubmitting }) => (
            <div className="login-form">
              <Form>
                <div className="login-form-header">Kirjaudu</div>
                <div className="login-form-input">
                  <Field type="text" name="login" autoComplete="off" />
                </div>
                <div className="login-form-input">
                  <Field type="password" name="password" />
                </div>
                <div className="login-form-footer">
                  <button
                    className="modal-footer-submit-button"
                    type="submit"
                    onClick={handleSubmit}
                  >
                    Kirjaudu
                  </button>
                </div>
              </Form>
            </div>
          )}
        />
      </div>
    </div>
  );
};

export default withRouter(Login);
